import { render, staticRenderFns } from "./MarketingMailConfig.vue?vue&type=template&id=57bc6e80&scoped=true&"
import script from "./MarketingMailConfig.vue?vue&type=script&lang=js&"
export * from "./MarketingMailConfig.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMailConfig.vue?vue&type=style&index=0&id=57bc6e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc6e80",
  null
  
)

export default component.exports